export default function getPlatform(userAgent) {
  switch (true) {
    case !!(userAgent && userAgent.match(/(ipod|iphone|ipad)/i)):
      return 'ios';
    case !!(userAgent && userAgent.match(/android/i)):
      return 'android';
    default:
      return undefined;
  }
}
